{
  "contactCustomerService": "联系客服",
  "close": "关闭",
  "notConfigured": "客服尚未设定",
  "temporarilyUnavailable": "客服暂时无法载入",
  "retry": "重试"
}
